import styled from '@emotion/styled'

export const Container = styled.a`
  position: fixed;
  bottom: 2rem;
  right: 0;
  background: green;
  width: 60px;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px 0 0 12px;
  background: #0DC143;
  cursor: pointer;
  z-index: 99;
  transition: all .15s ease-in-out;

  &:hover {
    transform: scale(1.3);
    right: 10px;
  }
`
